export * from './lib/page-wrapper.module';
export { PageWrapperComponent } from './lib/page-wrapper/page-wrapper.component';
